// extracted by mini-css-extract-plugin
export default {"footerLogo":"Footer_footerLogo__XUarC"};